import {
    GET_AWARD_REQUEST,
    GET_AWARD_SUCCESS,
    GET_AWARD_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const getAwardReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_AWARD_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case GET_AWARD_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case GET_AWARD_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default getAwardReducer;
